var r,t;function n(){if(t)return r;t=1;var n=String;return r=function(r){try{return n(r)}catch(r){return"Object"}}}export{n as __require};
//# sourceMappingURL=try-to-string.js.map
